export const ScreenComponentProp = Object.freeze({
    ScreenComponentType: 'componentType',
    Position: 'position',
    Name: 'name',
});